import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { retryWhen, mergeMap } from 'rxjs/operators';

// Optional: import Sentry
import * as Sentry from '@sentry/angular';

@Injectable()
export class RetryInterceptor implements HttpInterceptor {
  private readonly maxRetries = 3;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.method !== 'GET') {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      retryWhen((errors) =>
        errors.pipe(
          mergeMap((error, retryCount) => {
            if (!(error instanceof HttpErrorResponse)) {
              return throwError(() => error);
            }

            if (retryCount >= this.maxRetries) {
              return throwError(() => error);
            }

            if ([0, 502, 504].includes(error.status)) {
              const backoff = 1000 * (retryCount + 1);

              // 🔄 Soft logging
              console.warn(
                `[RetryInterceptor] Retrying ${req.url} (attempt ${retryCount + 1}) after error:`,
                error.status,
                error.message,
              );

              // Add breadcrumb to Sentry (not a full error capture)
              Sentry.addBreadcrumb({
                category: 'http',
                message: `Retrying GET ${req.url} (attempt ${retryCount + 1})`,
                level: 'warning',
                data: { status: error.status },
              });

              return timer(backoff);
            }

            return throwError(() => error);
          }),
        ),
      ),
    );
  }
}
